import styled from "styled-components";

export const BackofficeContainer = styled.div`
    padding-top: 1%;
    background-color: white;
`